export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/14ed8dc335eec8ccd043173219a4387f.svg";